export default __webpack_public_path__ + "static/media/cinnamon-roll.0e11c8bd.jpg";